import styled from 'styled-components';

const CreateEmployeeDialogStyles = styled.div`
  min-width: 320px;
  max-width: 460px;

  h3 {
    margin-bottom: 10px;
  }

  .section {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .end-date-row {
    min-height: 46px;
  }
`;

export default CreateEmployeeDialogStyles;
